export const SET_SELECTED_MAM_PROFILE = "SET_SELECTED_MAM_PROFILE";
export const GET_MAM_PROFILES_START = "GET_MAM_PROFILES_START";
export const GET_MAM_PROFILES_SUCCESS = "GET_MAM_PROFILES_SUCCESS";
export const GET_MAM_PROFILES_FAIL = "GET_MAM_PROFILES_FAIL";
export const GET_MAM_PROFILE_START = "GET_MAM_PROFILE_START";
export const GET_MAM_PROFILE_SUCCESS = "GET_MAM_PROFILE_SUCCESS";
export const GET_MAM_PROFILE_FAIL = "GET_MAM_PROFILE_FAIL";
